import type { DeepReadonly } from 'vue'
import { SlideTypes } from '@/entities/deck'
import type { Slide } from '@/entities/deck'

export function useSlideTypeRedirect(slides: DeepReadonly<Ref<Slide[]>>, deckId: string | number, isEmbed: boolean = false) {
  const checkAndRedirect = () => {
    const includesv3 = slides.value.some(s => s.type === SlideTypes.Scene || s.type === SlideTypes.ThreeSixty)
    const includesV2 = slides.value.some(s => s.type === SlideTypes.Model)

    if (includesv3 && !includesV2) {
      if (isEmbed) {
        window.location.href = `/embed/presentations/${deckId}`
      } else {
        window.location.href = `/beta/decks/${deckId}`
      }
    }
  }

  return { checkAndRedirect }
}
